export default __webpack_public_path__ + "1033761aa4fd8aa2ecf6153f7dedd9f2.png";